<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索">
                    <el-input
                      v-model="form.activity_fee_refund_no"
                      placeholder="退费单号"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="form.supply_id" placeholder="商家ID" />
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.supply_name"
                      placeholder="商家名称"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.pay_admin"
                      placeholder="支付人"
                      clearable
                    />
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.pay_status"
                      placeholder="活动退费状态"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in pay_status_option"
                        :key="index"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.pay_tool"
                      placeholder="支付方式"
                      style="width: 150px"
                    >
                      <el-option value="">全部</el-option>
                      <el-option
                        v-for="(item, index) in pay_tool_option"
                        :key="index"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="退费单生成日期：" style="width: 600px">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="退费日期：" style="width: 500px">
                    <el-date-picker
                      v-model="form.pay_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <div style="margin-left: auto">
            <el-button type="primary" size="mini" @click="handleBatchCommit()">
              退费转账/分账</el-button
            >
            <el-button type="success" size="mini" @click="handleExport">
              导出列表</el-button
            >
          </div>
        </div>
        <div v-if="resData.length > 0" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="activity_fee_refund_no"
              label="退费单号"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="created_at"
              label="退费单生成日期"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_tool_text"
              label="支付方式"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_id"
              label="商家ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="brand_name"
              label="品牌"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_num"
              label="商品总数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_amount"
              label="活动费退费总额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_status_text"
              label="活动费退费状态"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_admin_name"
              label="支付人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_time"
              label="退费日期"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row.id)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData.length > 0" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="total"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>

        <div v-if="checkVisible">
          <pay-tem
            :ids="modalFormData.ids"
            :url="payUrl"
            :pay_num="modalFormData.pay_num"
            :pay_money="modalFormData.pay_money"
            furinfo="用于商家活动费用退费"
            title="退费支付"
            @onCloseDialog="onCloseDialog"
          ></pay-tem>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import { listRefundOrder } from "@/controller/finance.js";
import PayTem from "./wcgorder/components/PayOrderTem.vue";
import apiBaseURL from "@/utils/baseUrl.js";

const PAY_STATUS_UNPAID = "1";
export default {
  name: "ActivityRefundDetail",
  components: {
    PayTem,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: [],
      total: 0,
      search_options: [
        { key: "wave_picking_no", name: "波次号" },
        { key: "shipping_num", name: "快递单号" },
        { key: "user_id", name: "用户id" },
        { key: "consignee", name: "收件人姓名" },
      ],
      form: {
        activity_fee_refund_no: "",
        supply_id: "",
        supply_name: "",
        pay_admin: "",
        pay_status: "",
        pay_time: [],
        pay_tool: "",
        create_time: this.defaultDate(),
        page: "",
        pagesize: 100,
        is_excel: 0,
      },
      payUrl: "/erp/ActivityFeeRefund/payActivityRefundOrder",
      pay_status_option: [],
      pay_tool_option: [],
      loading: false,
      url: "/erp/ActivityFeeRefund/listRefundOrder",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      checkVisible: false,
      modalFormData: {
        pay_num: 0,
        pay_money: 0,
      },
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      const arr = cloneDeep(this.form);
      for (const key in arr) {
        if (arr[key] === undefined || arr[key] === "" || arr[key] === null) {
          delete arr[key];
        }
      }
      return arr;
    },
  },
  methods: {
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },
    handleSubmit() {
      this.checkVisible = false;
      this.fetchData(true);
    },
    handleDetail(id) {
      this.$router.push({
        path: `/home/purchasing/activityRefundList/detail/${id}`,
      });
    },
    // 退费支付
    handleBatchCommit() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请选择退费单");
        return;
      }
      const ids = [];
      let pay_amount = 0;
      let isCanSubmit = true;
      for (const item of this.multipleSelection) {
        ids.push(item.id);
        pay_amount += +item.pay_amount;
        if (item.pay_status !== PAY_STATUS_UNPAID) {
          this.$message.error(
            `退费单${item.activity_fee_refund_no}的当前状态为'${item.pay_status_text}'，只能对'待支付’的退费单进行付款`
          );
          isCanSubmit = false;
          break;
        }
      }
      if (isCanSubmit) {
        this.modalFormData.pay_num = this.multipleSelection.length;
        this.modalFormData.pay_money = pay_amount;
        this.modalFormData.ids = ids;
        this.checkVisible = true;
      }
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 14);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onCloseDialog(e) {
      this.checkVisible = false;
      this.fetchData();
    },
    handleExport() {
      this.form.is_excel = 1;
      this.loading = true;
      listRefundOrder(this.form)
        .then((data) => {
          const { file } = data;
          console.log(11111, data);
          this.loading = false;
          this.form.is_excel = 0;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.loading = true;
      this.fetchData(true);
    },
    fetchData(showLoading) {
      listRefundOrder(this.form)
        .then((data) => {
          const { list, total, pay_status_option, pay_tool_option } = data;
          this.resData = list;
          this.total = total;
          this.pay_tool_option = pay_tool_option;
          this.pay_status_option = pay_status_option;
        })
        .catch(this.$noop);
      if (showLoading) {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.el-table .stock-row {
  background: #f7fd7b;
}

.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ActivityRefundList.vue